const tab_sections = {
    identity: 'Идентификация',
    integrations: 'Подключения',
    login_security: 'Вход и безопасность',
    permissions: 'Разрешения',
    automation: 'Автоматизация',
    platform: 'Платформа',
    overview: 'Обзор',
    authentication: 'Аутентификация',
    authorization: 'Авторизация',
    users: 'Пользователи',
    developer: 'Разработчик',
    tenant: 'Арендатор',
};
export default Object.freeze(tab_sections);
